import { css } from "@emotion/react";

export const FONT = (type: string, size: number, weight: number, lineHeight: number = 1.5) => {
    let result = type === "cormorant" && "Cormorant";

    if (type === "notoSerif") {
        result = "Noto Serif KR";
    }

    if (type === "pretendard") {
        result = "Pretendard Variable";
    }

    return {
        fontFamily: `${result} !important`,
        fontSize: `${size}px !important`,
        fontWeight: `${weight} !important`,
        lineHeight: `${lineHeight} !important`,
    };
};

export const FLEX = {
    normal: (horizon: string, vertical: string, type: string = "flex") => {
        return css`
            display: ${type};
            justify-content: ${horizon};
            align-items: ${vertical};
        `;
    },

    row: (horizon: string, vertical: string, columnGap: number, type: string = "flex") => {
        return css`
            display: ${type};
            flex-direction: row;
            column-gap: ${columnGap}px;
            justify-content: ${horizon};
            align-items: ${vertical};
        `;
    },

    column: (horizon: string, vertical: string, rowGap: number, type: string = "flex") => {
        return css`
            display: ${type};
            flex-direction: column;
            row-gap: ${rowGap}px;
            justify-content: ${horizon};
            align-items: ${vertical};
        `;
    },
};

export const RADIUS = (radius: number) => {
    const result = radius < 25 ? `${radius * 4}px` : `${radius}%`;

    return {
        borderRadius: `${result}`,
    };
};
